import { drypApi } from "@/services/drypApi";
import { lensApi } from "@/services/lensApi";
interface Overlay {
	overlayId: Dryp.OverlayId;
	name: string;
	type: string;
	gridSizeX: number;
	gridSizeY: number;
	latitudeSW: number;
	longitudeSW: number;
	latitudeNE: number;
	longitudeNE: number;
	minZoom: number | null;
	maxZoom: number | null;
	epsg: string | null;
	baseURL: string | null;
	parameters: {
		transparent: boolean;
		layers: string | null;
		format: string | null;
		styles: string | null;
		attribution: string | null;
	} | null;
	elevation: number;
	timeStepMinutes: number | null;
	titleField: {
		title: string;
		key: string;
		type: string;
	} | null;
	popupFields:
		| {
				title: string;
				key: string;
				type: string;
		  }[]
		| null;
	color: string | null;
	sensorTypeIds: number[] | null;
	accumulationMinutes: number[] | null;
}
export const overlay = {
	getAll: async (): Promise<Overlay[]> => {
		try {
			const response = await lensApi.get<Overlay[]>("/overlays");

			return response;
		} catch (error) {
			return [];
		}
	},
	getOverlay: async (overlayId: Dryp.OverlayId, bbox: string): Promise<any> => {
		try {
			const response = await drypApi.get<any>(`/api/overlays/${overlayId}?bbox=${bbox}`);
			return response;
		} catch (error) {
			return;
		}
	},
};
